/**
 * Business / SP message from epidemiology or sensitivity ATB endpoints (msgType &gt; 0).
 * Consumers should map msgCode to `WEB_RESULTS.EPIDEMIOLOGY.*` i18n keys for display.
 */
export class EpidemiologyError extends Error {
  constructor(
    public readonly msgCode: string,
    public readonly msgType: number
  ) {
    super(msgCode);
    this.name = 'EpidemiologyError';
    Object.setPrototypeOf(this, EpidemiologyError.prototype);
  }
}
